import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    payload: Object,
    lowConfidence: Boolean,
  };

  connect() {
    this.element.classList.add("cursor-pointer");
    if (this.lowConfidenceValue) {
      this.element.classList.add("border-warning/60");
    }
  }

  focus() {
    this.dispatchWindowEvent("ocr-source:focus");
  }

  clear() {
    this.dispatchWindowEvent("ocr-source:clear");
  }

  jump(event) {
    if (event.target.closest("a, button, input, select, textarea, label")) {
      return;
    }

    this.dispatchWindowEvent("ocr-source:jump");
  }

  dispatchWindowEvent(name) {
    window.dispatchEvent(
      new CustomEvent(name, {
        detail: this.payloadValue,
      })
    );
  }
}
